import React from "react";
import { ArrowRight, Calendar, CheckCircle, FileText, Plus } from "lucide-react";

export default function StudentTimelineSection({
  viewingStudent,
  visitLogs,
  attendanceLogs,
  icons,
  onOpenLog
}) {
  const history = [];

  visitLogs
    .filter((log) => log.studentId === viewingStudent.id)
    .forEach((log) => {
      history.push({
        type: "visit",
        date: new Date(log.date),
        title: log.type === "상담"
          ? "마음을 나눴던 소중한 시간"
          : log.type === "기도"
            ? "함께 마음 모아 기도했습니다"
            : "삶의 자리에서 함께했습니다",
        content: log.content,
        icon: log.type === "상담"
          ? <FileText size={16} />
          : log.type === "기도"
            ? <img src={icons.prayer} width={16} alt="pray" />
            : <CheckCircle size={16} />,
        color: log.type === "상담"
          ? "bg-blue-500 shadow-blue-200"
          : log.type === "기도"
            ? "bg-indigo-500 shadow-indigo-200"
            : "bg-[#354F38] shadow-emerald-200",
        raw: log
      });
    });

  const attendanceHistory = attendanceLogs
    .filter((log) => log[viewingStudent.id])
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 5);

  attendanceHistory.forEach((log) => {
    const status = log[viewingStudent.id];
    if (status === "present" || status === "late") {
      history.push({
        type: "attendance",
        date: new Date(log.date),
        title: status === "present" ? "예배의 자리를 지켰습니다" : "조금 늦었지만, 함께해서 기쁩니다",
        icon: <Calendar size={16} />,
        color: status === "present" ? "bg-emerald-500 shadow-emerald-200" : "bg-amber-500 shadow-amber-200"
      });
    }
  });

  if (viewingStudent.createdAt) {
    history.push({
      type: "system",
      date: viewingStudent.createdAt.toDate ? viewingStudent.createdAt.toDate() : new Date(viewingStudent.createdAt),
      title: "The STAFF 부원 등록",
      content: "우리 공동체와 함께한 시작일이에요! 🌱",
      icon: <Plus size={16} />,
      color: "bg-gray-800 shadow-gray-200"
    });
  }

  const sortedHistory = history.sort((a, b) => b.date - a.date);

  if (sortedHistory.length === 0) {
    return (
      <div className="py-12 flex flex-col items-center gap-4 opacity-50">
        <img src={icons.memo} width={40} className="grayscale" alt="empty" />
        <p className="text-sm font-bold text-gray-400">활동 기록이 비어있습니다</p>
      </div>
    );
  }

  return sortedHistory.map((item, idx) => (
    <div key={idx} className="relative pl-12 group cursor-default transition-all duration-300">
      <div className={`absolute left-0 top-1 w-8 h-8 rounded-2xl ${item.color} shadow-lg z-10 flex items-center justify-center text-white transform group-hover:scale-110 transition-transform duration-300 ${idx === 0 ? "animate-pulse" : ""}`}>
        {item.icon}
      </div>

      <div className="bg-white/40 backdrop-blur-sm rounded-2xl p-4 border border-white hover:bg-white hover:shadow-xl hover:shadow-gray-200/50 transition-all duration-500">
        <div className="flex flex-col gap-1">
          <span className="text-[10px] font-black text-[#354F38]/40 uppercase tracking-widest">{item.date.toLocaleDateString("ko-KR", { year: "2-digit", month: "long", day: "numeric" })}</span>
          <h4 className="text-sm font-black text-gray-800">{item.title}</h4>
          {item.content && (
            <p className="text-xs text-gray-500 font-medium leading-relaxed mt-1 break-keep p-3 bg-gray-50/50 rounded-xl border border-gray-100 line-clamp-3 group-hover:line-clamp-none transition-all duration-500">
              {item.content}
            </p>
          )}
          {item.type === "visit" && (
            <button onClick={() => onOpenLog(item.raw)} className="text-[10px] font-bold text-[#354F38] mt-2 flex items-center gap-1 hover:underline">상세 보기 <ArrowRight size={10} /></button>
          )}
        </div>
      </div>
    </div>
  ));
}
